var hierarchy = {
  compactBox: require('./compact-box'),
  dendrogram: require('./dendrogram'),
  indented: require('./indented'),
  mindmap: require('./mindmap')
};
module.exports = hierarchy;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/hierarchy/lib/index.js
// module id = 101
// module chunks = 0